import React from 'react'

function Header() {
  return (
    <>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
            <div class="container px-4 px-lg-5">
                <a class="navbar-brand" href="#viewna">Viewna-Cafe</a>
                <button class="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    
                    <i class="fas fa-bars"></i>
                </button>
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav ms-auto">
                        <li class="nav-item"><a class="nav-link" href="#Info">Info</a></li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Menu
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <li><a class="dropdown-item" href="#projects">Foods</a></li>
                                <li><a class="dropdown-item" href="#water">Drinks</a></li>
                               
                            </ul>
                        </li>
                        {/* <li class="nav-item"><a class="nav-link" href="#projects">Food</a></li>
                        <li class="nav-item"><a class="nav-link" href="#water">Drink</a></li> */}
                        <li class="nav-item"><a class="nav-link" href="#signup">Contact</a></li>
                    </ul>
                </div>
            </div>
        </nav>
        <header class="masthead">
            <div class="container px-4 px-lg-5 d-flex h-100 align-items-center justify-content-center">
                <div class="d-flex justify-content-center">
                    <div class="text-center">
                        <h1 class="mx-auto my-0 text-uppercase">Viewna Cafe</h1>
                        <h2 class="text-white-50 mx-auto mt-2 mb-5">โฮมคาเฟ่กลางทุ่งนา มีที่นั่งทั้ง Indoor และ Outdoor ให้บริการกาแฟสด เบเกอรี่โฮมเมด สเต็ก พิซซ่า รสชาติเยี่ยม
                        </h2>
                        <h2 class="text-white-50 mx-auto mt-2 mb-5">
                        ร้านเปิดทุกวัน 10.00-18.00 น.</h2>
                        <a class="btn btn-primary" href="#viewna">Visit</a>
                    </div>
                </div>
            </div>
        </header>
    </>
  )
}

export default Header